import { gql } from '@apollo/client';

export default gql`
  mutation makeCustomerPresentCardPayment(
    $bookingReference: String!
    $amount: Float!
    $currency: Currency!
    $terminalId: String!
    $cashRegisterId: String!
    $isSplitPayment: Boolean!
    $isFlowForwardCapped: Boolean
  ) {
    makeCustomerPresentCardPayment(
      bookingReference: $bookingReference
      amount: $amount
      currency: $currency
      terminalId: $terminalId
      cashRegisterId: $cashRegisterId
      isSplitPayment: $isSplitPayment
      isFlowForwardCapped: $isFlowForwardCapped
      isDepositPayment: false
    ) {
      booking {
        reference
      }
      receipt {
        paymentStatus
        date
        time
        stan
        apacs50tn
        paymentMethod
        mid
        cardNumber
        authMethod
        terminalId
        authCode
        aid
        panSeq
        totalAmount
      }
    }
  }
`;
